import script from "./participate.vue?vue&type=script&lang=ts&setup=true"
export * from "./participate.vue?vue&type=script&lang=ts&setup=true"

import "./participate.vue?vue&type=style&index=0&id=c96a0398&lang=scss"
/* custom blocks */
import block0 from "./participate.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "./participate.vue?vue&type=custom&index=1&blockType=i18n&locale=ko"
if (typeof block1 === 'function') block1(script)
import block2 from "./participate.vue?vue&type=custom&index=2&blockType=i18n&locale=ja"
if (typeof block2 === 'function') block2(script)


const __exports__ = script;

export default __exports__